module.exports = __webpack_public_path__ + "static/media/BrixSans-Bold.3d7e6125.woff";